module.exports = __webpack_public_path__ + "img/magna.6cb64243.jpg";